import { GetReplenishmentThresholdsVm } from './get-replenishment-thresholds.vm';
import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getReplenishmentThresholds = async (
  offset: string,
  warehouseId: string,
  locationId: string,
  productId: string,
  callback: CallbackObject<GetReplenishmentThresholdsVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      limit: 50,
      offset: offset
    },
  };

  if (locationId) {
    config.params.locationId = locationId
  }

  if (productId) {
    config.params.productId = productId
  }


  try {
    const res: AxiosResponse = await instance.get(`/replenishment/warehouses/${warehouseId}/thresholds`, config);
    callback.success(plainToClass(GetReplenishmentThresholdsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
